function MfbAplicacionesEs() {
	return (
		<section className="tu-product-copy invy-text">
			<h2>
				Motores hidráulicos de pistones: reemplazos directos estilo Vickers para
				maquinaria industrial y móvil
			</h2>

			<h3>Reemplazo de motores hidráulicos Vickers para equipos industriales</h3>
			<p>
				¿Necesita reemplazar un motor hidráulico de pistones Vickers en una máquina
				industrial o equipo móvil? En Technical Union (TU), ayudamos a distribuidores
				industriales, empresas de mantenimiento, talleres hidráulicos y fabricantes de
				maquinaria a encontrar motores hidráulicos de reemplazo para aplicaciones que
				requieren potencia, torque y funcionamiento confiable.
			</p>
			<p>
				Nuestros motores hidráulicos de pistones de reemplazo estilo Vickers están
				dirigidos a quienes buscan una alternativa para reparar equipos existentes,
				mantener maquinaria en operación y reducir los tiempos de inactividad. La
				selección del motor adecuado depende de las especificaciones del motor original
				y de los requisitos del sistema hidráulico.
			</p>

			<h3>Aplicaciones de los motores hidráulicos de pistones</h3>
			<p>
				Los motores hidráulicos de pistones se utilizan en sistemas que requieren alta
				densidad de potencia, control de velocidad y capacidad para trabajar bajo
				condiciones exigentes. Según el diseño y las especificaciones del motor, pueden
				emplearse en aplicaciones como:
			</p>
			<ul>
				<li>
					<strong>Accionamientos industriales:</strong> equipos que requieren movimiento
					rotativo controlado y transmisión de potencia hidráulica.
				</li>
				<li>
					<strong>Maquinaria de construcción:</strong> excavadoras, cargadores, equipos de
					movimiento de tierra y maquinaria auxiliar con accionamientos hidráulicos
					compatibles.
				</li>
				<li>
					<strong>Maquinaria agrícola:</strong> tractores, cosechadoras y equipos
					agrícolas que utilizan motores hidráulicos para accionar mecanismos
					específicos.
				</li>
				<li>
					<strong>Equipos de manufactura:</strong> maquinaria de producción, equipos de
					procesamiento y sistemas industriales accionados hidráulicamente.
				</li>
				<li>
					<strong>Equipos de manejo de materiales:</strong> maquinaria de elevación,
					transporte y manipulación de materiales con accionamientos hidráulicos.
				</li>
				<li>
					<strong>Maquinaria móvil especializada:</strong> equipos industriales y
					comerciales que necesitan un motor hidráulico compatible con su circuito
					original.
				</li>
			</ul>
			<p>
				La aplicación específica determina el desplazamiento, la presión de trabajo, la
				velocidad, el torque y la configuración de montaje necesarios.
			</p>

			<h3>Industrias que utilizan motores hidráulicos de pistones</h3>
			<p>
				Los motores hidráulicos de pistones de reemplazo pueden ser relevantes para
				empresas de distintos sectores, entre ellos:
			</p>
			<ul>
				<li>Industria manufacturera y metalmecánica.</li>
				<li>Construcción y movimiento de tierra.</li>
				<li>Agricultura y maquinaria agroindustrial.</li>
				<li>Minería y manejo de materiales.</li>
				<li>Mantenimiento y reparación de maquinaria pesada.</li>
				<li>Fabricación e integración de sistemas hidráulicos.</li>
				<li>Distribución de componentes hidráulicos y repuestos industriales.</li>
			</ul>
			<p>
				Para distribuidores y talleres de reparación, identificar una alternativa
				compatible con el motor original facilita la búsqueda de repuestos para clientes
				que necesitan mantener sus equipos existentes.
			</p>

			<h3>¿Busca un reemplazo para un motor hidráulico Vickers?</h3>
			<p>
				Cuando un motor hidráulico Vickers presenta desgaste, pérdida de rendimiento o
				una falla mecánica, sustituirlo por una unidad compatible puede ayudar a
				restablecer la operación del equipo sin modificar innecesariamente el diseño del
				sistema.
			</p>
			<p>
				Technical Union ofrece asistencia comercial para identificar alternativas de
				reemplazo estilo Vickers según las especificaciones disponibles.
			</p>
			<p>Para comprobar la compatibilidad, es importante comparar:</p>
			<ul>
				<li>
					<strong>Número de modelo o número de parte:</strong> la referencia del motor
					original ayuda a identificar la configuración requerida.
				</li>
				<li>
					<strong>Desplazamiento hidráulico:</strong> determina el volumen de fluido
					necesario por revolución.
				</li>
				<li>
					<strong>Presión de operación:</strong> debe corresponder a las condiciones
					reales de trabajo del circuito.
				</li>
				<li>
					<strong>Velocidad y torque:</strong> deben satisfacer los requisitos de la
					máquina.
				</li>
				<li>
					<strong>Montaje y eje:</strong> deben coincidir con la interfaz mecánica del
					equipo.
				</li>
				<li>
					<strong>Puertos y conexiones:</strong> deben ser compatibles con las líneas
					hidráulicas existentes.
				</li>
				<li>
					<strong>Sentido de giro y drenaje de carcasa:</strong> deben cumplir los
					requisitos del sistema original.
				</li>
			</ul>
			<p>
				No todos los motores de pistones son intercambiables directamente. La
				compatibilidad debe confirmarse con la referencia y las especificaciones
				técnicas antes de seleccionar un reemplazo.
			</p>

			<h3>Motores hidráulicos para mantenimiento, reparación y repuestos</h3>
			<p>
				Encontrar el motor correcto es importante para empresas que necesitan reducir el
				tiempo de parada de sus máquinas. Una selección adecuada permite mantener las
				características de funcionamiento previstas y evitar problemas derivados de
				diferencias en desplazamiento, presión, montaje o conexiones.
			</p>
			<p>
				Technical Union trabaja con fabricantes y socios industriales para ayudar a
				distribuidores, talleres hidráulicos, departamentos de mantenimiento y
				fabricantes de maquinaria a identificar soluciones para sus necesidades de
				repuestos y reemplazos hidráulicos.
			</p>

			<h3>
				Solicite información sobre motores hidráulicos de reemplazo estilo Vickers
			</h3>
			<p>
				Si busca un motor hidráulico de pistones para reemplazar una unidad Vickers,
				consulte nuestra página de productos y envíenos la información del motor
				original.
			</p>
			<p>
				Para agilizar la identificación, incluya el número de parte, fotografías de la
				placa de identificación, datos de montaje y las especificaciones disponibles de
				presión, desplazamiento y velocidad.
			</p>
			<p>
				<strong>Visite nuestra página de motores hidráulicos de pistones:</strong>
			</p>
			<p>
				<a href="/es/productos/hidraulicos/motores/motores_de_pistones">
					https://www.tu.biz/es/productos/hidraulicos/motores/motores_de_pistones
				</a>
			</p>
			<p>
				<strong>
					Contacte a Technical Union (TU) para solicitar información técnica y una
					cotización de motores hidráulicos de reemplazo.
				</strong>
			</p>
		</section>
	);
}

function MfbAplicacionesEn() {
	return (
		<section className="tu-product-copy invy-text">
			<h2>
				Hydraulic piston motors: direct Vickers-style replacements for industrial
				and mobile machinery
			</h2>

			<h3>Vickers hydraulic motor replacement for industrial equipment</h3>
			<p>
				Need to replace a Vickers piston hydraulic motor on an industrial machine
				or mobile equipment? At Technical Union (TU), we help industrial
				distributors, maintenance companies, hydraulic shops, and machinery
				manufacturers find replacement hydraulic motors for applications that
				require power, torque, and reliable operation.
			</p>
			<p>
				Our Vickers-style replacement piston hydraulic motors are for buyers who
				need an alternative to repair existing equipment, keep machinery running,
				and reduce downtime. Choosing the right motor depends on the original
				motor specifications and the requirements of the hydraulic system.
			</p>

			<h3>Piston hydraulic motor applications</h3>
			<p>
				Piston hydraulic motors are used in systems that need high power density,
				speed control, and the ability to work under demanding conditions.
				Depending on the motor design and specifications, they can be used in
				applications such as:
			</p>
			<ul>
				<li>
					<strong>Industrial drives:</strong> equipment that needs controlled
					rotary motion and hydraulic power transmission.
				</li>
				<li>
					<strong>Construction machinery:</strong> excavators, loaders, earthmoving
					equipment, and auxiliary machinery with compatible hydraulic drives.
				</li>
				<li>
					<strong>Agricultural machinery:</strong> tractors, harvesters, and farm
					equipment that use hydraulic motors to drive specific mechanisms.
				</li>
				<li>
					<strong>Manufacturing equipment:</strong> production machinery, processing
					equipment, and hydraulically driven industrial systems.
				</li>
				<li>
					<strong>Material handling equipment:</strong> lifting, conveying, and
					material-handling machinery with hydraulic drives.
				</li>
				<li>
					<strong>Specialized mobile machinery:</strong> industrial and commercial
					equipment that needs a hydraulic motor compatible with its original
					circuit.
				</li>
			</ul>
			<p>
				The specific application determines the displacement, working pressure,
				speed, torque, and mounting configuration required.
			</p>

			<h3>Industries that use piston hydraulic motors</h3>
			<p>
				Replacement piston hydraulic motors can be relevant for companies in
				several sectors, including:
			</p>
			<ul>
				<li>Manufacturing and metalworking.</li>
				<li>Construction and earthmoving.</li>
				<li>Agriculture and agro-industrial machinery.</li>
				<li>Mining and material handling.</li>
				<li>Heavy-equipment maintenance and repair.</li>
				<li>Hydraulic system manufacturing and integration.</li>
				<li>Distribution of hydraulic components and industrial spare parts.</li>
			</ul>
			<p>
				For distributors and repair shops, identifying an alternative compatible
				with the original motor makes it easier to find parts for customers who
				need to keep existing equipment in service.
			</p>

			<h3>Looking for a Vickers hydraulic motor replacement?</h3>
			<p>
				When a Vickers hydraulic motor shows wear, loss of performance, or a
				mechanical failure, replacing it with a compatible unit can help restore
				equipment operation without changing the system design more than
				necessary.
			</p>
			<p>
				Technical Union provides commercial assistance to identify Vickers-style
				replacement options from the specifications on hand.
			</p>
			<p>To check compatibility, compare:</p>
			<ul>
				<li>
					<strong>Model number or part number:</strong> the original motor
					reference helps identify the required configuration.
				</li>
				<li>
					<strong>Hydraulic displacement:</strong> the fluid volume required per
					revolution.
				</li>
				<li>
					<strong>Operating pressure:</strong> it should match the circuit’s real
					working conditions.
				</li>
				<li>
					<strong>Speed and torque:</strong> they should meet the machine’s
					requirements.
				</li>
				<li>
					<strong>Mounting and shaft:</strong> they should match the equipment’s
					mechanical interface.
				</li>
				<li>
					<strong>Ports and connections:</strong> they should be compatible with
					the existing hydraulic lines.
				</li>
				<li>
					<strong>Direction of rotation and case drain:</strong> they should meet
					the original system requirements.
				</li>
			</ul>
			<p>
				Not every piston motor is a direct interchange. Compatibility should be
				confirmed against the reference and the technical specifications before a
				replacement is selected.
			</p>

			<h3>Hydraulic motors for maintenance, repair, and spare parts</h3>
			<p>
				Finding the correct motor matters for companies that need to reduce
				machine downtime. A suitable selection keeps the intended operating
				characteristics and avoids problems caused by differences in displacement,
				pressure, mounting, or connections.
			</p>
			<p>
				Technical Union works with manufacturers and industrial partners to help
				distributors, hydraulic shops, maintenance departments, and machinery
				builders identify solutions for hydraulic spare parts and replacements.
			</p>

			<h3>Request information on Vickers-style replacement hydraulic motors</h3>
			<p>
				If you are looking for a piston hydraulic motor to replace a Vickers unit,
				review our product page and send the original motor information.
			</p>
			<p>
				To speed identification, include the part number, photos of the nameplate,
				mounting details, and the available pressure, displacement, and speed
				specifications.
			</p>
			<p>
				<strong>Visit our hydraulic piston motors page:</strong>
			</p>
			<p>
				<a href="/en/products/hydraulics/motors/piston-motors">
					https://www.tu.biz/en/products/hydraulics/motors/piston-motors
				</a>
			</p>
			<p>
				<strong>
					Contact Technical Union (TU) to request technical information and a
					quotation for replacement hydraulic motors.
				</strong>
			</p>
		</section>
	);
}

export default function MfbAplicaciones({ locale = "es" }) {
	return locale === "en" ? <MfbAplicacionesEn /> : <MfbAplicacionesEs />;
}

